import React from 'react'
import Edit from '../../crud/edit'
import FieldList from '../../fieldList'

const FieldBreakdown = ({ value, errorText, onChange, resource, ...props }) => {
  const handleFieldChange = (field, e, fieldValue) => {
    const updatedValue = Object.assign({}, value, {
      [field.prop]: fieldValue
    })

    onChange(e, updatedValue)
  }

  return (
    <div>
      {errorText && <p style={{ color: 'red' }}>All fields are required</p>}

      <FieldList
        resource={value || {}}
        errors={errorText || {}}
        onChange={handleFieldChange}
        {...props}
      />
    </div>
  )
}

const usertypeMappingFields = [
  {
    name: 'Individual',
    prop: 'individual',
    type: 'text'
  },
  {
    name: 'Sub-Account',
    prop: 'subaccount',
    type: 'text'
  },
  {
    name: 'Primary Account Holder',
    prop: 'primary_account_holder',
    type: 'text'
  }
]

const fields = [
  {
    name: 'Usertypes',
    prop: 'value',
    type: 'component',
    component: FieldBreakdown,
    componentProps: {
      fields: usertypeMappingFields
    }
  }
]
const EditSettings = props => {
  return (
    <Edit
// @ts-ignore
      title='Edit MailChimp Usertype Interests'
      fields={fields}
      apiPath='admin/settings/mailchimp_usertype_mapping'
      successRedirectPath='/settings'
      buildMenuItems={() => {}}
      disableDelete
    />
  )
}

export default EditSettings
